import { VFC } from "react";
import { css } from "src/styles/theme";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  InfoCircledIcon,
  HamburgerMenuIcon,
} from "@radix-ui/react-icons";
import { APP_CONFIG } from "src/constants";
import { DropdownMenu } from "./dropdown-menu";
import { useSPALink } from "src/hooks/use-spa-link.hook";
import { useMatchRoute } from "@tanstack/react-location";

export const AppMenu: VFC = () => {
  const navigate = useSPALink();
  const matchRoute = useMatchRoute();
  const isOnHome = matchRoute({ to: "/" });

  return (
    <nav className={$nav()}>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger className={$menuTrigger()}>
          <HamburgerMenuIcon />
          <span>Menu</span>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content sideOffset={4}>
          {isOnHome && (
            <DropdownMenu.Item asChild>
              <a href="/app" onClick={navigate}>
                <ArrowRightIcon />
                <span>Open app</span>
              </a>
            </DropdownMenu.Item>
          )}
          {!isOnHome && (
            <DropdownMenu.Item asChild>
              <a href="/" onClick={navigate}>
                <ArrowLeftIcon />
                <span>Back to home</span>
              </a>
            </DropdownMenu.Item>
          )}
          <DropdownMenu.Separator />
          <DropdownMenu.Item asChild>
            <a
              href={APP_CONFIG.authorWebsiteUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <InfoCircledIcon />
              <span>About</span>
            </a>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </nav>
  );
};

const $nav = css({
  position: "fixed",
  top: "$6",
  left: "$6",
  zIndex: 10,
});

const $menuTrigger = css({
  applyReset: "btn",
  display: "flex",
  alignItems: "center",
  gap: "$2",
  justifyContent: "center",
  padding: "$3 $4",
  color: "$primaryText",
  fontSize: "$sm",
  borderRadius: "$2",
  boxShadow: "$2",
  backgroundColor: "$background",

  svg: {
    width: "1rem",
    height: "1rem",
  },
});
